





















import { Vue, Component, Prop } from 'vue-property-decorator';
import BackgroundCoin from '@/components/icons/BackgroundCoin.vue';
import {
  calculateResizeMargin,
  calculateResizePercentage
} from '@/utils/resize';

const componentSize = 75;

@Component({
  components: {
    BackgroundCoin
  }
})
export default class WelcomeCoin extends Vue {
  @Prop(String) value!: string;
  @Prop({ default: '75' }) size!: string;

  get textValue() {
    return this.value;
  }

  get countryData() {
    return this.$store.getters['internationalization/getCountrySettings'];
  }

  get currencySymbol() {
    return this.countryData.currencySymbol;
  }

  get calculateSize() {
    return calculateResizePercentage(componentSize, this.size);
  }

  get calculateMargin() {
    return calculateResizeMargin(componentSize, this.size);
  }
}
